module.exports = __webpack_public_path__ + "public/images/testimonial-top-doodle.cfffb870e831208a639e707dff42d5b1.webp";